export default __webpack_public_path__ + "static/image6-8524f44d50756ec280f7a00afcb257bd.jpeg";